export default __webpack_public_path__ + "static/Yoga-f793789fe513c026fa4a5135cec5afe7.svg";